<div class="auth-page bg-blue-500">
  <div class="auth-card">
    <div class="flex align-items-center justify-content-center mb-4">
      <img src="assets/images/logo/logo-monicase-vertical.png" alt="" class="auth-logo" />
    </div>

    <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="email">Adresse email</label>
        <input
          type="email"
          id="email"
          formControlName="email"
          placeholder="ex: user@mail.com"
          [readOnly]="authService.isLoading"
        />
        <div class="error" *ngIf="submitted && f['email'].errors">
          <span *ngIf="f['email'].errors?.['required']">Email requis</span>
          <span *ngIf="f['email'].errors?.['email']">Email invalide</span>
        </div>
      </div>

      <div class="text-green-500 mb-3" *ngIf="successMessage">
        {{ successMessage }}
      </div>
      <div class="text-red-500 mb-3" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <p-button
        type="submit"
        label="Envoyer le lien"
        [loading]="authService.isLoading"
        [disabled]="authService.isLoading"
        styleClass="w-full bg-blue-500"
      ></p-button>

      <div class="mt-3 text-center">
        <a class="text-blue-500 pointer" (click)="onSignIn()">Retour à la connexion</a>
      </div>
    </form>
  </div>
</div>